import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1168,601.321321 L1168,676.276276 C1240.31231,631.351351 1323.7958,605.165165 1450.64264,605.165165 C1863.4955,605.165165 1916.34835,913.753754 1916.34835,1182.58258 L1916.34835,1182.58258 L1916.34835,1915.7958 L1438.99099,1920 L1438.99099,1218.73874 C1438.99099,1101.02102 1396.82883,1078.67868 1318.87087,1078.67868 C1244.75676,1078.67868 1198.75075,1102.1021 1198.75075,1218.73874 L1198.75075,1218.73874 L1198.75075,1920 L715.147147,1915.7958 L715.147147,601.321321 L1168,601.321321 Z M480.48048,600.528529 L480.48048,1919.44745 L0,1919.44745 L0,600.528529 L480.48048,600.528529 Z M360.36036,720.648649 L120.12012,720.648649 L120.12012,1799.32733 L360.36036,1799.32733 L360.36036,720.648649 Z M1047.87988,721.441441 L835.267267,721.441441 L835.267267,1796.75676 L1078.63063,1798.91892 L1078.63063,1218.73874 C1078.63063,992.312312 1229.14114,958.558559 1318.87087,958.558559 C1428.42042,958.558559 1559.11111,1003.72372 1559.11111,1218.73874 L1559.11111,1218.73874 L1559.11111,1798.91892 L1796.22823,1796.75676 L1796.22823,1182.58258 C1796.22823,849.249249 1702.65465,725.285285 1450.64264,725.285285 C1299.17117,725.285285 1233.58559,770.21021 1169.32132,824.264264 L1169.32132,824.264264 L1152.62462,838.438438 L1047.87988,838.438438 L1047.87988,721.441441 Z M240.24024,-2.5243549e-29 C372.732733,-2.5243549e-29 480.48048,107.747748 480.48048,240.24024 C480.48048,372.732733 372.732733,480.48048 240.24024,480.48048 C107.747748,480.48048 0,372.732733 0,240.24024 C0,107.747748 107.747748,-2.5243549e-29 240.24024,-2.5243549e-29 Z M240.24024,120.12012 C174.054054,120.12012 120.12012,174.054054 120.12012,240.24024 C120.12012,306.426426 174.054054,360.36036 240.24024,360.36036 C306.426426,360.36036 360.36036,306.426426 360.36036,240.24024 C360.36036,174.054054 306.426426,120.12012 240.24024,120.12012 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconLinkedinLine = /*#__PURE__*/function (_Component) {
  _inherits(IconLinkedinLine, _Component);

  var _super = _createSuper(IconLinkedinLine);

  function IconLinkedinLine() {
    _classCallCheck(this, IconLinkedinLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconLinkedinLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconLinkedin",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconLinkedinLine.displayName = "IconLinkedinLine";
  return IconLinkedinLine;
}(Component);

IconLinkedinLine.glyphName = 'linkedin';
IconLinkedinLine.variant = 'Line';
IconLinkedinLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconLinkedinLine;
export { IconLinkedinLine };